import { api } from "@/api/client";
import type { User } from "@/types";

export async function fetchUsers(): Promise<User[]> {
  const { data } = await api.get<User[]>("/users");
  return data;
}

export async function createUser(input: { email: string; name?: string }): Promise<User> {
  const { data } = await api.post<User>("/users", input);
  return data;
}

export async function setUserActive(id: number, active: boolean): Promise<User> {
  const { data } = await api.patch<User>(`/users/${id}`, { active });
  return data;
}

export type PosterFlag = "lightreach_ar_poster" | "payment_sync_poster";
export type CollectionsFlag = "collections_reminder_sender" | "collections_invoice_creator";
export type CloseReviewFlag = "close_reviewer";
export type EmailFlag = "email_responder";
export type PermissionFlag = PosterFlag | CollectionsFlag | CloseReviewFlag | EmailFlag;

export async function setUserPermission(id: number, flag: PermissionFlag, value: boolean): Promise<User> {
  const { data } = await api.patch<User>(`/users/${id}`, { [flag]: value });
  return data;
}

export async function resendInvite(id: number): Promise<void> {
  await api.post(`/users/${id}/resend_invite`);
}
